<template>
  <div>


    <span class="white--text">{{userInfo.name}}</span>

    <v-menu bottom left v-model="menu" :close-on-content-click="false">
      <v-btn icon slot="activator" class="mt-0">
        <v-layout align-center justify-space-around wrap>
          <v-avatar size="40px">
            <img :src="`${serverPath}/assets/${userImage}`" :alt="userInfo.name" />
          </v-avatar>
        </v-layout>
      </v-btn>

      <v-list style="width:350px;">
        <div>
          <v-list>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <img :src="`${serverPath}/assets/${userImage}`" />
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>{{userInfo.name}}</v-list-tile-title>
                <v-list-tile-sub-title>
                  {{userInfo.email}}
                </v-list-tile-sub-title>   

              </v-list-tile-content>



              <v-list-tile-action>
                <v-list-tile-content>

                  <v-list-tile-sub-title>
                    <v-btn small color="primary" flat to="/dashboard">
                      <v-icon>dashboard</v-icon> Dashboard
                    </v-btn>
                  </v-list-tile-sub-title>   

                  <v-list-tile-sub-title>
                    <v-btn small color="warning" flat @click="logout()">
                      <v-icon>settings_power</v-icon> Logout &nbsp;&nbsp;&nbsp;&nbsp;
                    </v-btn>
                  </v-list-tile-sub-title> 

                </v-list-tile-content>
              </v-list-tile-action>

            </v-list-tile>
          </v-list>

          <!-- ============== Dropdown Menu List ============== -->
          <v-list>
            <v-list-group            
            prepend-icon="dashboard"
            no-action
            >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>Modules</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>

            <v-list-tile v-for="(val,key) in main_menu_list" :key="key" v-if="val.dashboard>0">
              <v-list-tile-avatar>
                <img v-if="val.icon_name" :src="`${FrontendPath}/public/dashboard/${val.icon_name}`" />
                <img v-else :src="`${FrontendPath}/public/dashboard/logo.png`" />
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  <div @click="activeModule(val)" class="page-submenu-list__link" style="text-decoration:none; cursor: pointer;">
                    {{ val.menu_name }}
                  </div>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

          </v-list-group>
        </v-list>
        <!-- ============== /Dropdown Menu List ============== -->
      </div>
    </v-list>
  </v-menu>  

</div>  
</template>

<script>
let UtilService = require("../services/util.service");
import ServerPath from "../server-path/server-path";
let Encrypted = require("../services/encrypted");
import { FrontendPath } from "../vuex/api";
export default {
  
  data() {
    return {
      FrontendPath:FrontendPath,
      menu: false,
      clipped: false,
      main_menu_list: [],
      userInfo: {
        name: "",
        email: ""
      },
      userImage: "default_profile_pic.png",

      serverPath: "",
      head_items: [
        {
          action: "dashboard",
          title: "Modules",
          active: true,
          sub_items: []
        }
      ]
    };
  },

  created: function() {
    let user = UtilService.getUserName();

    this.serverPath = ServerPath.serverPath;
    this.userInfo.name = user.name;
    this.userInfo.email = user.email;

    if (sessionStorage.getItem("auth") == "yes") {
      this.main_menu_list = JSON.parse(Encrypted.base64_decode(localStorage.getItem("roleDetails")));      
      this.$store.commit("SET_USER_ROLE_DATA", this.main_menu_list);
    } else this.main_menu_list = this.getMenuList;

    //console.log('main_menu_list', this.main_menu_list);
    
  },

  methods: {
    triggerRoute: function(path) {
      this.$router.push({ path: path });
    },
    logout: function() {
      this.$router.push({ path: "/security/logout" });
    },

    //This function used for dashboard menu
    activeModule: function(val) {
      localStorage.setItem("module", val.menu_name);
      this.$store.commit('SET_KEY_VALUE',val.menu_name);
      this.$store.commit('SET_MODULE_NAME',val.menu_name);
      this.$router.push({ path: val.main_route });
      sessionStorage.removeItem("ActiveMenu")
      //location.reload()
      this.menu = false;
    }
  },
  computed: {
  
    getMenuList: function() {
       let getMainMenuList = this.$store.getters.getUserRoleDetails
      
      return this.$store.getters.getUserRoleDetails;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/header.vue